import { render, staticRenderFns } from "./my-commission.vue?vue&type=template&id=328d73f4&"
import script from "./my-commission.vue?vue&type=script&lang=js&"
export * from "./my-commission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports